'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { NavItem } from '../lib/docs';

interface DocsSidebarProps {
  navigation: NavItem[];
}

export default function DocsSidebar({ navigation }: DocsSidebarProps) {
  const pathname = usePathname();

  return (
    <aside className="hidden md:block w-64 border-r border-gray-200 h-screen sticky top-16 overflow-y-auto bg-white">
      <nav className="p-6 space-y-8">
        {navigation.map((section) => (
          <div key={section.title}>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">
              {section.title}
            </h3>
            {section.items && (
              <ul className="space-y-2">
                {section.items.map((item) => (
                  <li key={item.href}>
                    <Link
                      href={item.href || '#'}
                      className={`block text-sm py-1 px-3 rounded-md transition-colors ${
                        pathname === item.href
                          ? 'bg-lime-100 text-gray-900 font-medium'
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </nav>
    </aside>
  );
}
